import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { subscribeWithSelector as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { handleSubscribers as n } from "@magnopus-opensource/connected-spaces-platform-web-api";
var r = e(t((e, t) => ({
	stack: [],
	size: 0,
	cursor: -1,
	currentState: void 0,
	push: (n) => {
		let r = t().stack, i = t().cursor + 1;
		r[i] = n, e(() => ({
			currentState: {
				type: "push",
				action: n.action,
				value: n.toValue
			},
			size: i + 1,
			cursor: i,
			stack: r
		}));
	},
	undo: () => {
		let { stack: n, cursor: r, size: i } = t();
		if (i > 0) {
			let t = Math.max(-1, r - 1), i = n[r];
			i && e(() => ({
				currentState: {
					type: "undo",
					action: i.action,
					value: i.fromValue
				},
				cursor: t
			}));
		}
	},
	redo: () => {
		let { stack: n, cursor: r, size: i } = t(), a = r + 1;
		if (a < i) {
			let t = n[a];
			e(() => ({
				currentState: {
					type: "redo",
					action: t.action,
					value: t.toValue
				},
				cursor: a
			}));
		}
	},
	clear: () => {
		e({
			stack: [],
			size: 0,
			cursor: -1,
			currentState: void 0
		});
	}
})));
n(r);
//#endregion
export { r as undoRedoState };
